<template>
  <div id="homeDown" class="homeDown ">
    <div class="honDown_left">
      <div class="title defaultFamily">{{$t('home_v2_100')}}</div>
      <div class="content">
        <div class="left">
          <div class="text">
            <svg class="ficon">
                <use xlink:href="#bf-tag-line" />
              </svg>
            <p>{{$t('home_v2_101')}}</p>
          </div>
          <div class="text">
            <svg class="ficon">
                <use xlink:href="#bf-tag-line" />
              </svg>
            <p v-html="$t('home_v2_102')"></p>
          </div>
          <div class="box">
            <a href="https://apps.apple.com/us/app/bitforex-pro/id1616084745" target="_blank"><img src="./imgs/img_AppStore3x.png" alt=""></a>
            <a href="https://play.google.com/store/apps/details?id=com.bitforex.bitforex" target="_blank"><img src="./imgs/GooglePlay.png" alt=""></a>
            <a href="https://download.bitforex.com/app/assets/res/BitForex.apk" target="_blank"><img src="./imgs/img_Android3x.png" alt=""></a>
            <a @click="isMobileShow = true"><img src="./imgs/img_MobileWeb@3x.png" alt=""></a>
          </div>
          <div @click="go($t('link_api'))" class="doc">
            <img src="./imgs/Fill.png" alt="">
            {{$t('home_v2_24')}}</div>
        </div>
        <div class="right">
          <div class="box">
            <img src="./imgs/img_android_down_en_2.jpg" alt="">
            <p>{{$t('home_v2_20')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="honDown_right">
      <img src="./imgs/img_Model@2x.png" alt="">
    </div>
    <bf-dialog :visible="isMobileShow" :title="$t('home_65')" widht="340px" :show-close="false" class="erweima">
      <div class="mobile-qrcode">
        <!-- <qrcode-vue :value="mobileUrl" :size="140" level="L" class="qr-code" /> -->
        <img src="./imgs/SQ@2x.png" alt="">
      </div>
      <div class="bf-button__default" @click="isMobileShow = false">
        {{ $t('form_76') }}
      </div>
    </bf-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
const getLan = (locale) => {
  if (!['cn', 'en', 'jp', 'kr', 'ru', 'hk'].includes(locale)) {
    locale = 'en';
  }
  return locale;
};
export default {
  name: 'HomeDown',
  components: {
    QrcodeVue
  },
  data () {
    return {
      isMobileShow: false,
      isHide: false,
      curDownTips: ''
    };
  },
  methods: {
    go (url) {
      window.open(url);
    },
    onDownAndroid () {
      window.location.href = `https://download.bitforex.com/app/assets/res/BitForex.apk`;
    },
    onDownIOS () {
      window.location.href = this.iOSDownUrl;
    }
    // mouseEnter (type) {
    //   if (this.isMobile) {
    //     return;
    //   }
    //   this.curDownTips = type === 0 ? this.$t('down.androidQrcode') : this.$t('down.iosQrcode');
    //   this.isHide = false;
    // },
    // mouseLeave () {
    //   if (this.isMobile) {
    //     return;
    //   }
    //   this.isHide = true;
    // }
  },
  mounted () {
    // this.isMobile = isMobile();
    // console.log(this.isMobile, isMobile());
    // this.isHide = !this.isMobile;
  },
  computed: {
    ...mapState({
      locale: state => state.common.locale,
      imgUrlData: state => {
        let locale = getLan(state.common.locale);
        return {
          // qrcodeUrl: require(`./imgs/img_android_down_${locale}.jpg`),
          qrcodeUrl: require(`./imgs/img_android_down_${locale}_2.png`),
          phoneUrl: require(`./imgs/img_pixeltex_${locale}.png`)
        };
      },
      iOSDownUrl: state => {
        // let locale = getLan(state.common.locale);
        // return `https://download.bitforex.com/app/${locale}.html`;
        // return `https://m.bitforex.com/${locale}/download`;
        return `https://apps.apple.com/us/app/bitforex-pro/id1616084745`;
      },
      mobileUrl: state => {
        let locale = getLan(state.common.locale);
        return `https://m.bitforex.com/${locale}/home`;
      }
    }),
    noticeLink () {
      const lang = ['cn', 'en', 'kr', 'ru', 'jp'].includes(this.locale) ? this.locale : 'en';
      const obj = {
        cn: 'zh-cn',
        en: 'en-us',
        kr: 'ko',
        ru: 'ru'
      };
      return `https://support.bitforex.com/hc/${obj[lang]}/articles/360033765952`;
    }
  }
};
</script>

<style lang="scss">

// @import "../../theme-default.scss";
.homeDown {
  z-index: 1;
  width: 1200px;
  height: 846px;
  padding-top: 120px;
  padding-bottom: 260px;
  margin: 0 auto;
  position: relative;
  .erweima{
    .bf-dialog{
      width: 390px;
      padding: 56px 40px;
      text-align: center;
      background: #14C393;
      box-shadow: 0px 20px 36px -8px rgba(14, 14, 44, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.05);
      border-radius: 16px;
      .bf-dialog__header{
        .bf-dialog__title{
          font-weight: 600;
          font-size: 24px;
          line-height: 134%;
          text-align: center;
          letter-spacing: -0.02em;
          color: #FFFFFF;
        }
      }
      .bf-dialog__body{
        margin-top: 32px;
        .mobile-qrcode{
          margin: 0 auto;
          width: 212px;
          height: 212px;
          background: #FFFFFF;
          padding: 16px;
          box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15), 0px 4px 8px rgba(0, 0, 0, 0.2);
          border-radius: 16px;
          img{
            width: 180px;
            height: 180px;
          }
        }
        .bf-button__default{
          margin: 0px auto;
          margin-top: 32px;
          width: 288px;
          height: 48px;
          border: 1px solid #FFFFFF;
          border-radius: 8px;
          padding: 12px 24px;
          font-weight: 500;
          font-size: 16px;
          line-height: 150%;
          color: #FFFFFF;
          &:hover{
            background: #FFFFFF;
            color: #0E0E2C;
          }
        }
      }
    }
  }
  .honDown_left{
    width: 696px;
    .title{
      font-style: normal;
      font-weight: 500;
      font-size: 40px;
      line-height: 120%;
      letter-spacing: -0.02em;
      color: #0E0E2C;
      margin-bottom: 64px;
      text-align: left;
    }
    .content{
      display: flex;
      .left{
        .text{
          display: flex;
          align-items: center;
          img{
            width: 9px;
            height: 9px;
          }
          .ficon{
            width: 24px;
            height: 24px;
            color: #14C393;
          }
          p{
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 150%;
            color: #4A4A68;
            margin-left: 4px;
          }
        }
        .text:nth-child(2){
          margin-top: 8px;
        }
        .box{
          display: flex;
          flex-flow: wrap;
          margin-bottom: 24px;
          a{
            cursor: pointer;
            margin-top: 24px;
            margin-right: 24px;
            img{
              width: 210px;
            }
          }
        }
        .doc{
          padding: 4px 8px 4px 4px;
          background: #F7F8FA;
          border: 1px solid #ECF1F4;
          border-radius: 4px;
          display: inline;
          cursor: pointer;
          img{
            vertical-align: sub;
          }
        }
      }
      .right{
        .box{
          width: 204px;
          background: #F7F8FA;
          border-radius: 16px;
          padding: 12px;
          img{
            width: 180px;
            height: 180px;
          }
          p{
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            text-align: center;
            color: #0E0E2C;
          }
        }
      }
    }
  }
  .honDown_right{
    position: absolute;
    left: 778px;
    top: 46px;
    img{
      width: 814px;
      height: 800px;
    }
  }
  .title{
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 42px;
    text-align: center;
    color: #000000;
    margin-bottom: 51px;
  }
}

</style>
